var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('table',{staticClass:"table operative-table",class:{ 'table-sm': _vm.dense, 'sticky': _vm.sticky }},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }